module.exports = __webpack_public_path__ + "src/assets/img/cmd-clear-immo.dbf458e4.svg";